import { useMemo, useState } from "react";
import { MapPin } from "lucide-react";
import LocationSelector from "@/components/location/LocationSelector";

export default function LocationDemoPage() {
  const [sel, setSel] = useState({ province: "", city: "", district: "", subdistrict: "" });

  const selectedCount = useMemo(
    () => [sel.province, sel.city, sel.district, sel.subdistrict].filter(Boolean).length,
    [sel]
  );

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="location-demo-page">
      <div className="mb-8">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary text-xs font-bold uppercase tracking-[0.2em] text-primary">
          <MapPin size={14} /> Master Lokasi Indonesia
        </span>
        <h1 className="mt-4 font-heading text-3xl lg:text-4xl font-bold tracking-tight">
          Cascading Location Selector
        </h1>
        <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
          Pilih bertahap: Provinsi → Kota/Kabupaten → Kecamatan → Kelurahan/Desa.
          Mengubah parent akan mereset dan memuat ulang pilihan child.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-card border border-border rounded-2xl p-6">
          <LocationSelector onChange={setSel} />
        </div>

        <div className="bg-card border border-border rounded-2xl p-6" data-testid="location-selection-output">
          <h3 className="font-heading text-lg font-semibold mb-4">Pilihan Saat Ini</h3>
          <dl className="space-y-3 text-sm">
            {[
              ["Provinsi", sel.province],
              ["Kota/Kabupaten", sel.city],
              ["Kecamatan", sel.district],
              ["Kelurahan/Desa", sel.subdistrict],
            ].map(([label, val]) => (
              <div key={label} className="flex items-center justify-between gap-4 border-b border-border pb-2">
                <dt className="text-muted-foreground">{label}</dt>
                <dd className="font-mono text-xs text-foreground truncate max-w-[60%]">
                  {val || "—"}
                </dd>
              </div>
            ))}
          </dl>
          <p className="mt-4 text-xs text-muted-foreground">
            {selectedCount}/4 level terpilih. ID di atas adalah identifier yang dikirim ke API.
          </p>
        </div>
      </div>
    </div>
  );
}
